import { watch } from 'vue'
import { useNotificationStore } from '@/legacy/store/modules/notification'
import { usePayerStore } from '@/legacy/store/modules/payers'
import { useStaffStore } from '@/legacy/store/modules/staff'
import { NotificationType } from '@/legacy/types/notifications'
import { useWhoAmI } from './whoAmI'

/**
 * Composable that fetches global catalog data (staff, payers) whenever
 * the current user's entityId changes.
 *
 * IMPROVEME(TEA-548, TEA-549): These stores should be converted to Vue Query
 * so that they are fetched on demand the first time they are needed,
 * rather than eagerly on login.
 */
export function useGlobalData() {
  const { selfEntityId } = useWhoAmI()

  watch(selfEntityId, async (newId) => {
    if (newId) {
      try {
        await Promise.all([
          useStaffStore().fetchStaff(),
          usePayerStore().fetchPayers(),
        ])
      } catch (err) {
        console.error('Failed to fetch staff or payers:', err)
        useNotificationStore().setNotification({
          message: 'Failed to fetch staff or payers.',
          type: NotificationType.DANGER,
        })
      }
    }
  })
}
